import { AxiosError } from 'axios';

import { LEAD_REFERRALS_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';

export type CreateLeadReferralApiPayload = {
  referred_user_id: string;
  referrer_user_id?: string;
};

export type LeadReferralResponse = {
  id: string;
  referred_user_id: string;
  referrer_user_id: string;
  org_id: string;
  created_at: string;
  updated_at: string;
};

const createLeadReferral = async (
  payload: CreateLeadReferralApiPayload
): Promise<ApiResponse<LeadReferralResponse>> => {
  try {
    const response = await apiManager.post(LEAD_REFERRALS_API_URL, payload, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default createLeadReferral;
